module.exports = __webpack_public_path__ + "img/dd.c27098ca.png";